import { render, staticRenderFns } from "./ProductItem4.vue?vue&type=template&id=e179a14a&"
import script from "./ProductItem4.vue?vue&type=script&lang=js&"
export * from "./ProductItem4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports